module.exports = __webpack_public_path__ + "static/media/image1.692717e5.PNG";